export default __webpack_public_path__ + "9682ec2bce3ca4e7489c047826cba9e4.png";